import { useContext } from 'react';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';

export const useRiskConditions = () => {
	const { jobRiskFactors, focusedId, setJobRiskFactors } =
		useContext(JobProfileContext);

	const index = jobRiskFactors.findIndex(
		(item) => item.jobProfileRiskFactor.id === focusedId,
	);
	const actualConditions =
		jobRiskFactors[index]?.jobProfileRiskFactor?.actualConditions || '';

	const recommendedActions =
		jobRiskFactors[index]?.jobProfileRiskFactor?.recommendedActions || '';

	const handleChange = (field: string, value: string) => {
		const index = jobRiskFactors.findIndex(
			(item) => item.jobProfileRiskFactor.id === focusedId,
		);

		const element = jobRiskFactors[index]?.jobProfileRiskFactor;

		if (element) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			jobRiskFactors[index].jobProfileRiskFactor[field] = value;
			setJobRiskFactors([...jobRiskFactors]);
		}
	};

	return {
		actualConditions,
		recommendedActions,
		handleChange,
	};
};
